module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt3_m_jp.604871ce7cfe5c03e10d49211b2e3630.png";